import multipleNav from './multipleNav/index';

export default {
  origins: [
    'http://localhost:9898'
  ],
  // 不需要鉴权路由的path
  excludePath: [
    '/',
    '/error',
    '/error/401',
    '/error/404'
  ],
  multipleNav,

  /**
   * @description: 集团SSO
   */
  sso: true, // true表示使用集团SSO,false表示不做登录验证
};
